'use client'

import { useMutation } from "@tanstack/react-query"
import { API_Error, API_Success_Response } from "@/interfaces/api/response/api_response_types"
import { API_Reset_Password_Response } from "@/interfaces/api/login/forgotPassword/api_response_types"
import { ResetPasswordData } from "@/interfaces/api/login/forgotPassword/api_request_types"
import { resetPassword } from "../requests/user"

export const useResetPassword = () => useMutation<API_Success_Response<API_Reset_Password_Response>, API_Error, ResetPasswordData>({
    retry: false,
    mutationFn: resetPassword
})